module.exports = __webpack_public_path__ + "static/img/question.794447c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question.png
// module id = 1280
// module chunks = 0